import React, { useState } from "react";
import "./login.scss";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (!username || !password) {
      setErrorMessage("Please enter username and password.");
      return;
    }

    localStorage.setItem("token", "demo-token");
    window.location.href = "/admin";
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__brand" aria-label="Hin Ho Lee Trading Sdn. Bhd.">
          <span>興和利貿易有限公司</span>
          <strong>Hin Ho Lee Trading Sdn. Bhd.</strong>
        </div>

        <h1 className="login-page__title">Admin Portal</h1>
        <p className="login-page__subtitle">Sign in to manage the Hin Ho Lee storefront</p>

        <form className="login-page__form" onSubmit={handleLogin}>
          <div className="login-page__field">
            <span className="login-page__icon">👤</span>
            <input
              className="login-page__input"
              type="text"
              placeholder="Username"
              value={username}
              autoComplete="username"
              onChange={(e) => {
                setUsername(e.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          <div className="login-page__field">
            <span className="login-page__icon">🔒</span>
            <input
              className="login-page__input"
              type="password"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => {
                setPassword(e.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          {errorMessage && (
            <div className="login-page__message login-page__message--error">
              {errorMessage}
            </div>
          )}

          <button type="submit" className="login-page__submit">
            Login
          </button>
        </form>
      </div>

      <div className="login-page__wave login-page__wave--one" />
      <div className="login-page__wave login-page__wave--two" />
    </div>
  );
};

export default LoginPage;
